/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Datetimeafteraspect8Inputs */



/**

* @param {_Filter_Class_Datetimeafteraspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_datetimeafteraspect8 = /** @type {((inputs?: _Filter_Class_Datetimeafteraspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Datetimeafteraspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("nach Datum")
});
export { _filter_class_datetimeafteraspect8 as "_filter_class_DateTimeAFTERAspect" }